// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LUXB","col":"styles_col__1KpTb"};